import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  selectedLang: localStorage.getItem('i18nextLng')?.slice(0, 2) ?? 'en',
  languages: [
    {
      label: 'English',
      code: 'en',
      icon: '/static/icons/ic_flag_en.svg',
    },
    {
      label: 'Spanish',
      code: 'es',
      icon: '/static/icons/ic_flag_es.svg',
    },
  ],
};

export const languageSlice = createSlice({
  name: 'language',
  initialState: INITIAL_STATE,
  reducers: {
    setLanguage: (state, action) => {
      const { code } = action.payload;
      const language = state.languages.find((lang) => lang.code === code);
      state.selectedLang = language.code;
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
